import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { useIsMobileBreakpoint } from '@elfsight/widget-utils';
import { useLocationCardProps } from '../location-card-settings-context';
import { LocationPhotoMedia } from '../location-photo-media';

export function BannerImageLayout({ children }: PropsWithChildren) {
  const {
    locationPhotoImage,
    locationPhotoPosition,
    locationPhotoDisplayMobile,
    locationPhotoMobilePosition,
    verticalPadding,
    horizontalPadding
  } = useLocationCardProps();
  const isMobileBreakpoint = useIsMobileBreakpoint(639);

  const bannerImageDisplayPosition = useMemo(() => {
    const hasImage = locationPhotoImage?.url;

    if (isMobileBreakpoint && hasImage) {
      return locationPhotoDisplayMobile
        ? locationPhotoMobilePosition
        : undefined;
    }

    if (locationPhotoPosition === 'center' && hasImage) {
      return 'top';
    }

    return undefined;
  }, [
    locationPhotoMobilePosition,
    locationPhotoDisplayMobile,
    locationPhotoPosition,
    locationPhotoImage,
    isMobileBreakpoint
  ]);

  return (
    <>
      {bannerImageDisplayPosition === 'top' && (
        <LocationPhotoMedia
          useHorizontalAspectRatio
          horizontalPadding={horizontalPadding}
          verticalPadding={verticalPadding}
          position="top"
        />
      )}

      {children}

      {bannerImageDisplayPosition === 'bottom' && (
        <LocationPhotoMedia
          useHorizontalAspectRatio
          horizontalPadding={horizontalPadding}
          verticalPadding={verticalPadding}
          position="bottom"
        />
      )}
    </>
  );
}
